import CONSTANTS from '../../../public/assets/constants';
import { getLiveChatUrl } from '@/utils/url';

export interface IItemProps {
  text: string;
  url: string;
  icon?: string;
  isOpen?: boolean;
  condition?: string;
  extras?: Record<string, any>;
  isDeepLink?: boolean;
  rule?: string;
}

export const getHelpMethodsConfig = (isLogin: boolean): IItemProps[] => {
  const { livechat, tel, email, face } = CONSTANTS.FOOTER;
  return [
    {
      url: getLiveChatUrl(),
      ...livechat,
    },
    tel,
    email,
    {
      url: isLogin
        ? 'rn/common/FACIAL-AUTH?scene=CS_SINGPASS_FACE_VERIFY'
        : 'rn/common/FACE-VERIFY-INFO?flowType=5',
      ...face,
    },
  ];
};
